import React, { Component } from 'react';
import { connect } from 'shalala';
import { Button, Row, Col } from 'react-bootstrap';

import { useStore } from '../../../store';
import Loading from '../../../facturotopia/loading/Loading';
import LoadingButton from '../../../facturotopia/LoadingButton';
import ResponseError from '../../../shared/responses/ResponseError';
import PopConfirm from '../../../facturotopia/popconfirm/PopConfirm';
import ResponseResult from '../../../shared/responses/ResponseResult';
import EmisorUpsertFiscalInfo from './components/EmisorUpsertFiscalInfo';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';

class EmisorUpdateFiscalInfo extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { data = {}, tenancy } = props;

    this.state = {
      data: data,
    };

    if (tenancy) {
      props.upsertActions.setPartialState({ tenancy });
    }

    props.upsertActions.setPartialState(this.state);
  }

  handleOnAction = (action: string) => {
    if (action === 'reset') {
      this.props.upsertActions.setPartialState({
        error: undefined,
        __action: action,
      });

      return;
    }

    if (action === 'cancel') {
      return;
    }

    if (action === 'confirm') {
      this.props.history.replace('/app/emisores');
    }

    if (!!this.props.onComplete) {
      this.props.onComplete();
    }
  };

  handleOnConfirm = async () => {
    const {
      data,
      data: { direccion = {} },
    } = this.props.upsert;
    const keys = Object.keys(data);

    let info = {};

    for (const key of keys) {
      if (data[key] !== null) {
        info[key] = data[key];
      }
    }

    delete info.id;
    delete info.status;
    delete info.RegistroPatronal;

    const body = {
      ...info,
      direccion: direccion,
      nomina: {
        RegistroPatronal: data.RegistroPatronal,
      },
    };

    await this.props.upsertActions.upsert(body, data.id);

    const { result } = this.props.upsert;

    if (!!result && this.props.onComplete) {
      this.props.onComplete(result);
    }
  };

  handleOnDataChange = (event) => {
    const newEvent = {
      ...event,
      steps: {
        fiscal_info: event.isValid,
      },
    };
    this.props.upsertActions.setStepDataChange(newEvent);
  };

  handleOnFiscalAddressDataChange = (event) => {
    let data = {
      ...this.props.upsert.data,
      direccion: event.data,
    };

    this.handleOnDataChange({
      ...event,
      data,
    });
  };

  renderError = () => {
    const { error } = this.props.upsert;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  renderResult = () => {
    const { result } = this.props.upsert;

    return (
      <div className="result-container">
        <ResponseResult
          title="Registro actualizado"
          result={result}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  render() {
    const { data = {}, error, result, isValid, busy, fetching } = this.props.upsert;

    const { onComplete } = this.props;

    if (fetching || !data.id) {
      return <Loading />;
    }

    return (
      <>
        {!!error && this.renderError()}

        {!!result && !onComplete && this.renderResult()}

        <EmisorUpsertFiscalInfo
          data={data}
          confirm={false}
          autoFocus={true}
          onDataChange={this.handleOnDataChange}
        />

        <Row>
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
            className="py-3"
          >
            <PopConfirm
              text="Realmente deseas cancelar?"
              onAction={this.handleOnAction}
            >
              <Button
                type="button"
                variant="secondary"
                disabled={busy}
                className="mr-2"
              >
                Cancelar
              </Button>
            </PopConfirm>

            <LoadingButton
              type="button"
              disabled={!isValid}
              loading={busy || false}
              onClick={this.handleOnConfirm}
            >
              {busy === true
                ? !data.id
                  ? 'Registrando...'
                  : 'Actualizando...'
                : !data.id
                ? 'Registrar'
                : 'Actualizar'}
            </LoadingButton>
          </Col>
        </Row>
      </>
    );
  }
}

const mapState = (store) => {
  return { upsert: store.app.emisores.upsert };
};

const mapActions = (actions) => {
  return { upsertActions: actions.app.emisores.upsert };
};

export default connect(useStore, mapState, mapActions)(withRouter(EmisorUpdateFiscalInfo));
